import React, { useEffect, useRef } from "react";
import { Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, ListGroup, ListGroupItem, Table } from "@/Components/ui";;
import Select from "react-select";

import { useNavigate, Link } from "react-router-dom";

import DeleteModal from "../../../Components/Common/DeleteModal";


import moment from "moment";
import TableContainer from "../../../Components/Common/TableContainer";
import { SUBDOMAIN } from "../../../assets/meta/meta";

const UserDetailInquiryList = ({ useInquiry }) => {
  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        id: "id",
      },
      {
        Header: "사용자",
        accessor: "phone_num",
        id: "phone_num",
      },
      {
        Header: "제목",
        accessor: "title",
        id: "title",
        Cell: (cellProps) => (
          <a href={`https://${SUBDOMAIN}.${window.AMZ_ENV.REACT_APP_DOMAIN}/inquiry/detail/${cellProps.row.original["id"]}`} target="_blank">
            {cellProps.row.original["title"]}
          </a>
        ),
      },
      {
        Header: "작성일",
        accessor: "written_date",
        id: "written_date",
        Cell: (cellProps) => {
          return <span>{moment(cellProps.row.original["written_date"]).format("YYYY-MM-DD HH:mm")}</span>;
        },
      },
    ],
    []
  );

  return (
    <div>
      <div>
        <React.Fragment>
          <TableContainer
            columns={columns}
            data={useInquiry || []}
            isGlobalFilter={false}
            isAddUserList={false}
            customPageSize={10}
            className="custom-header-css"
            isCustomerFilter={true}
            theadClass="table-light text-muted"
          />
        </React.Fragment>
      </div>
    </div>
  );
};

export default UserDetailInquiryList;
